
import React from "react";
import DonutChart from "./DonutChart";

/**
 * DonutChartWrapper
 * A simple, reusable wrapper for a Doughnut chart (or any chart) with:
 * - title + subtitle
 * - optional right-side header controls (buttons, toggles, etc.)
 * - stable chart area height
 *
 * Usage:
 * <DonutChartWrapper title="Occupancy" subtitle="Last 15 min" right={<MyToggle />}>
 *   <Doughnut data={...} options={...} />
 * </DonutChartWrapper>
 */

function walkTree(all_data, node, group_type, data_type, source_data, filters) {
    if (node.visible) {
        if (node.expand && node.children) {
            for (var key in node.children) {
                walkTree(all_data, node.children[key], key, data_type, source_data, filters);
            }

        }
        else {
            // debugger;
            var row = { ...source_data[node.level][data_type][group_type] }
            row = { ...row, ...filters[node.level].groups[group_type] }
            all_data.push(row)
        }
    }


    return all_data;
}

function pairDataAndMetadata(data, filters, group_type, data_type, value_type) {

    var data = walkTree([], group_type.all, "all", data_type, data, filters)

    return data.map(function (row) {

        switch (value_type) {
            case 'in': row.value = row.in; break;
            case 'out': row.value = row.out * -1; break;
            case 'net': row.value = row.in - row.out; break;
            case 'both': row.value = row.in + row.out; break;
            case 'both_rate_minute': row.value = row.in_rate_minute + row.out_rate_minute; break;
            case 'net_rate_minute': row.value = row.net_rate_minute; break;
            case 'in_rate_minute': row.value = row.in_rate_minute; break;
            case 'out_rate_minute': row.value = row.out_rate_minute * -1; break;
        }

        return row;
    })

}

export function DonutChartWrapper({
    data, filters, group_type, data_type, value, ...props
}) {

    let values = pairDataAndMetadata(data, filters, group_type, data_type, value);

    return (
        <DonutChart values={values} />
    );
}
